module.exports = __webpack_public_path__ + "static/media/image-xlsx.472c84e9.svg";